var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.345,
    height: 30.345,
    viewBox: "0 0 30.345 30.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(-148.994 -224.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(150.994 226.768)",
    fill: "#2197ed",
    stroke: "#3797ed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.172,
    cy: 13.172,
    r: 13.172,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.172,
    cy: 13.172,
    r: 14.172,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(156.879 234.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M11.11,4H7.466L5.644,6.186H3.458A1.458,1.458,0,0,0,2,7.644V14.2A1.458,1.458,0,0,0,3.458,15.66h11.66A1.458,1.458,0,0,0,16.575,14.2V7.644a1.458,1.458,0,0,0-1.458-1.458H12.931Z",
    transform: "translate(-2 -4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 2.058,
    cy: 2.058,
    r: 2.058,
    transform: "translate(5.229 4.94)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7cf0113797b638bde8904f2c3636c435.svg";
export { ForwardRef as ReactComponent };